<div 
    class="terminal-error-overlay"
    *ngIf="visible"
>
    <div class="terminal-error-modal" (click)="$event.stopPropagation()">
        <div class="terminal-error-header">
            <button type="button" (click)="close()"><i class="pi pi-times"></i></button>
        </div>

        <div class="terminal-error-bar">
            <strong>CollaboratorsApplication</strong>
        </div>

        <div class="terminal-error-body">
            <div
                class="terminal-error-line"
                *ngFor="let error of errors; let i = index"
                [style.--log-file-width.ch]="maxFileNameLength"
            >
                <span class="log-date">{{ getLogDate() }}</span>
                <span class="log-level">ERROR</span>
                <span>---</span>
                <span class="log-file" *ngIf="error.fileName">{{ error.fileName }}</span>
                <span style="padding: 0 3px;">:</span>
                <span class="log-message">{{ error.message }}</span>
            </div>
        </div>

        <div class="terminal-error-footer">
            <small style="display: flex; align-items: center; gap: 4px;"><i class="pi pi-times-circle"></i> {{ errors.length }}</small>
            <small style="margin-left: auto;">UTF-8</small>
        </div>
    </div>
</div>